export enum TagState {
  Success = 'success',
  Warning = 'warning',
  Danger = 'danger',
  Info = 'info',
  Disabled = 'disabled',
}
